module.exports = __webpack_public_path__ + "img/meme.e58b81ce.jpg";